import { FormConfig, FormValues } from "@/components/forms/types";
import { PriceLayer } from "@/data/entities";

type ProcessStatus = "pending" | "running" | "success" | "error";

interface ProcessStatusStep {
  key: string;
  label: string;
  status: ProcessStatus;
  detail?: string;
}

export const dialogEvents = {
  CategoryFormDialog: {
    OPEN: "CategoryFormDialog.Open",
    open: (id: string) => {
      window.dispatchEvent(
        new CustomEvent(dialogEvents.CategoryFormDialog.OPEN, {
          detail: { id },
        }),
      );
    },
    CLOSE: "CategoryFormDialog.Close",
    close: () => new CustomEvent(dialogEvents.CategoryFormDialog.CLOSE),
  },
  ConfirmDialog: {
    OPEN: "ConfirmDialog.Open",
    open: (
      message: string,
      onConfirm: () => Promise<void>,
      onCancel: () => Promise<void>,
    ) => {
      window.dispatchEvent(
        new CustomEvent(dialogEvents.ConfirmDialog.OPEN, {
          detail: { message, onConfirm, onCancel },
        }),
      );
    },
    CLOSE: "ConfirmDialog.Close",
    close: () => new CustomEvent(dialogEvents.ConfirmDialog.CLOSE),
  },
  OptionDialog: {
    OPEN: "OptionDialog.Open",
    open: (
      message: string,
      options: {
        [key: string]: {
          label: string;
          color?: string;
          handler: () => Promise<void>;
        };
      },
    ) => {
      window.dispatchEvent(
        new CustomEvent(dialogEvents.OptionDialog.OPEN, {
          detail: { message, options },
        }),
      );
    },
    CLOSE: "OptionDialog.Close",
    close: () => new CustomEvent(dialogEvents.OptionDialog.CLOSE),
  },
  InputDialog: {
    OPEN: "InputDialog.Open",
    open: (
      formConfig: FormConfig,
      formValues: FormValues,
      onSubmit: (values: FormValues) => Promise<void>,
    ) => {
      window.dispatchEvent(
        new CustomEvent(dialogEvents.InputDialog.OPEN, {
          detail: { formConfig, formValues, onSubmit },
        }),
      );
    },
    CLOSE: "InputDialog.Close",
    close: () => new CustomEvent(dialogEvents.InputDialog.CLOSE),
  },
  ProcessStatusDialog: {
    OPEN: "ProcessStatusDialog.Open",
    open: (detail: {
      title: string;
      message?: string;
      payload?: string;
      steps?: ProcessStatusStep[];
    }) => {
      window.dispatchEvent(
        new CustomEvent(dialogEvents.ProcessStatusDialog.OPEN, { detail }),
      );
    },
    UPDATE: "ProcessStatusDialog.Update",
    update: (detail: {
      title?: string;
      message?: string;
      payload?: string;
      state?: "running" | "success" | "error";
      errorMessage?: string;
      steps?: ProcessStatusStep[];
    }) => {
      window.dispatchEvent(
        new CustomEvent(dialogEvents.ProcessStatusDialog.UPDATE, { detail }),
      );
    },
    CLOSE: "ProcessStatusDialog.Close",
    close: () => new CustomEvent(dialogEvents.ProcessStatusDialog.CLOSE),
  },
  PriceLayerSelectDialog: {
    OPEN: "PriceLayerSelectDialog.Open",
    open: (callback: (item: PriceLayer) => void) => {
      window.dispatchEvent(
        new CustomEvent(dialogEvents.PriceLayerSelectDialog.OPEN, {
          detail: { callback },
        }),
      );
    },
    CLOSE: "PriceLayerSelectDialog.Close",
    close: () => new CustomEvent(dialogEvents.PriceLayerSelectDialog.CLOSE),
  },
  MediaFormDialog: {
    OPEN: "MediaFormDialog.Open",
    open: (id: string) => {
      window.dispatchEvent(
        new CustomEvent(dialogEvents.MediaFormDialog.OPEN, { detail: { id } }),
      );
    },
    CLOSE: "MediaFormDialog.Close",
    close: () => new CustomEvent(dialogEvents.MediaFormDialog.CLOSE),
  },
  CreateQuestionBundleFormDialog: {
    OPEN: "CreateQuestionBundleFormDialog.Open",
    open: (questionContextIds: string[]) => {
      window.dispatchEvent(
        new CustomEvent(dialogEvents.CreateQuestionBundleFormDialog.OPEN, {
          detail: { questionContextIds },
        }),
      );
    },
    CLOSE: "CreateQuestionBundleFormDialog.Close",
    close: () =>
      new CustomEvent(dialogEvents.CreateQuestionBundleFormDialog.CLOSE),
  },
  SelectQuestionBundleDialog: {
    OPEN: "SelectQuestionBundleDialog.Open",
    open: (questionContextIds: string[]) => {
      window.dispatchEvent(
        new CustomEvent(dialogEvents.SelectQuestionBundleDialog.OPEN, {
          detail: { questionContextIds },
        }),
      );
    },
    CLOSE: "SelectQuestionBundleDialog.Close",
    close: () => new CustomEvent(dialogEvents.SelectQuestionBundleDialog.CLOSE),
  },
  TagFormDialog: {
    OPEN: "TagFormDialog.Open",
    open: (id: string) => {
      window.dispatchEvent(
        new CustomEvent(dialogEvents.TagFormDialog.OPEN, { detail: { id } }),
      );
    },
    CLOSE: "TagFormDialog.Close",
    close: () => new CustomEvent(dialogEvents.TagFormDialog.CLOSE),
  },
};
